import { SchoolType } from '@/api/gql/graphql';
import { useValidateSchoolProposal } from '@/api/hooks/useSchool';
import { ColumnDefinition } from '@/components/Ui/DataTable/DataTable.type';
import { useHandleSchoolProposalForm } from '@/hooks/useSchoolProposalForm';
import { useToast } from '@/hooks/useToast';
import { useSchools } from '@/pages/Schools/schools.hook';
import { useSchoolStore } from '@/store/SchoolStore/SchoolStore';

export type ProposalType = {
  id: string;
  school: string;
  privateOrPublic?: string;
};

export const useSchoolProposalList = () => {
  const {
    isOpenSchoolProposalModal,
    openSchoolProposalModal,
    schoolProposal,
    setSchoolProposal,
    mode,
    setMode,
    schoolProposalListPage,
    setSchoolProposalListPage,
    schoolProposalListlimit,
    setSchoolProposalListLimit,
  } = useSchoolStore();
  const { showToast } = useToast();
  const { schoolsProposalsList } = useSchools();
  const { mutate: validateProposal, isPending } = useValidateSchoolProposal();

  const schoolType = [
    { _id: SchoolType.Private, name: SchoolType.Private },
    { _id: SchoolType.Public, name: SchoolType.Public },
  ];

  const columns: ColumnDefinition[] = [
    { field: 'school', header: 'Ecole' },
    { field: 'region', header: 'Région' },
    { field: 'privateOrPublic', header: 'Privée ou publique' },
    { field: 'action', header: 'Action', sortable: false },
  ];

  const { register, setValue, reset, handleSubmit } =
    useHandleSchoolProposalForm('update');

  const handleProposalValidation = (
    isValidated: boolean,
    successMessage: string,
  ) => {
    if (!schoolProposal?.id) return;

    validateProposal(
      { id: schoolProposal.id, isValidated },
      {
        onSuccess: () => {
          showToast(successMessage, 'success', {
            autoClose: 3000,
            position: 'top-right',
          });
          openSchoolProposalModal();
        },
        onError: (error) => {
          showToast(error?.message, 'error', {
            autoClose: 5000,
            position: 'top-right',
          });
        },
      },
    );
  };

  const onSubmit = () => handleProposalValidation(true, 'Ecole validée');

  const onRefuseProposal = () =>
    handleProposalValidation(false, 'Ecole refusée');

  return {
    columns,
    schoolsProposalsList,
    isOpenSchoolProposalModal,
    openSchoolProposalModal,
    schoolType,
    setSchoolProposal,
    schoolProposal,
    register,
    setValue,
    reset,
    handleSubmit,
    onSubmit,
    onRefuseProposal,
    isPending,
    setMode,
    mode,
    schoolProposalListPage,
    setSchoolProposalListPage,
    schoolProposalListlimit,
    setSchoolProposalListLimit,
  };
};
